module.exports = __webpack_public_path__ + "img/file_word_icon.5d9249cd.svg";